import { render, staticRenderFns } from "./personLargeDataScreen.vue?vue&type=template&id=47833964&scoped=true&"
import script from "./personLargeDataScreen.vue?vue&type=script&lang=js&"
export * from "./personLargeDataScreen.vue?vue&type=script&lang=js&"
import style0 from "./personLargeDataScreen.vue?vue&type=style&index=0&id=47833964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47833964",
  null
  
)

export default component.exports